exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-push{\r\nposition: absolute;\r\ntop: 49vh;\r\nleft: -26px;\n}\n.button-push:hover,.button-pop-up:hover{\r\ncursor: pointer;\n}\n.image-button{\r\ncolor: black;\r\nfont-size: 24px;\n}\r\n", ""]);

// exports
